import Vue from 'vue' // 使用标准ES模块导入
import App from './App.vue'

// 必须先注册 VueRouter 插件
import VueRouter from 'vue-router'
Vue.use(VueRouter) // 关键：必须在创建路由实例前注册插件

// 然后导入路由实例
import router from './router'

// 初始化 jQuery 并挂载到全局
import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

// 正确加载 Bootstrap（顺序很重要）
// import './assets/css/bootstrap.min.css' // 推荐使用npm包的路径
// import './assets/js/bootstrap.min.js' // 从node_modules加载Bootstrap JS

import 'bootstrap' // 导入 Bootstrap 样式
import 'bootstrap/dist/css/bootstrap.min.css'

// 导入 ElementUI 并注册
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 设置 axios 为全局属性
import axios from './api'
Vue.prototype.$http = axios // 使用 $ 前缀符合Vue规范

// 根据实际版本选择Swiper导入方式
// import 'swiper/swiper-bundle.min.css' // Swiper 6+（推荐）
import 'swiper/dist/css/swiper.min.css' // Swiper 5.x 及更早版本

// ======= 全局组件注册 =======

/* 头部组件 */
import Header from './components/Header.vue'
Vue.component(Header.name,Header)

import Footer from './components/Footer.vue'
Vue.component('Footer',Footer)

// /* 尾部组件 */
// import Footer from './components/Footer'
// Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop.vue'
Vue.component(GoTop.name,GoTop)

// ======= 全局配置 =======
Vue.config.productionTip = false

// ======= 路由导航守卫 =======
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) { // 安全访问 meta
    document.title = to.meta.title
  }
  next();
});

// ======= 创建 Vue 根实例 =======
new Vue({
  router, // 注入路由实例
  render: h => h(App) // 使用 render 函数，避免模板编译问题
}).$mount('#app') // 挂载到 #app